module.exports = __webpack_public_path__ + "img/game-screenshot-desktop.44d62692.png";